function ContactoTexto() {
    return (
        <>
            <div id="mensaje">
                <h1 id="contacto-titulo">CONTACTO</h1>
                <p>¿Tenés alguna consulta o recomendación?</p>
                <p>Te invitamos a comunicarte con nosotros<br></br>completando el siguiente formulario.</p>
                <p>¡Nos pondremos en contacto a la brevedad!</p>
            </div>
            <div id="contacto-ubicacion">
                <h4>También nos podés encontrar en nuestra casa taller:</h4>
                <p>Av. San Juan 2847</p>
                <p>C1232AAB — Barrio de San Cristóbal</p>
                <p>Ciudad Autónoma de Buenos Aires</p>
                <p>Argentina</p>

                <h4>Horarios:</h4>
                <p>Lunes a Viernes: 10:00 - 19:00</p>
                <p>Sábados: 10:00 - 14:00</p>
            </div>
        </>
    )
}

export default ContactoTexto